import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const filterStyles = makeStyles((theme) => ({
    root: {
        width: "500px"
    },
    titleBar: {
        borderBottom: "1px solid #E4E8EE"
    },
    title: {
        fontFamily: FontFamilySwitch().semiBold,
        color: "#091B29",
        fontSize: "1rem",
        //textAlign: "center"
    },
    clear: {
        fontFamily: FontFamilySwitch().semiBold,
        color: "#5078E1",
        fontSize: "0.875rem",
        cursor: "pointer"
    },
    filterTitle: {
        fontFamily: FontFamilySwitch().bold,
        color: "#091B29",
        fontSize: "1rem",
    },
    apply: {
        padding: "8px 12px",
        borderRadius: "10px",
    },
    seeMoreLessTextStyle: {
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.palette.primary.main,
    },
    applyRoot: {
        padding: "12px",
        borderTop: "1px solid #E4E8EE"
    },
    detailImg: {
        borderRadius: theme.palette.borderRadius,
        height: "176px",
        width: "100%",
        objectFit: "cover",
        cursor: "pointer"
    },
    Detailroot: {
        padding: "12px",
        height: `calc(100vh - 140px)`,
        overflow: "hidden"
    },
    Detailroot1: {
        padding: "12px",
        overflow: "hidden"
    },
    detailImg2: {
        borderRadius: theme.palette.borderRadius,
        height: "80px",
        width: "100%",
        objectFit: "cover"
    },
    detailTitle: {
        fontFamily: FontFamilySwitch().bold,
        color: "#091B29",
        fontSize: "1rem",
        marginTop: "4px"
    },
    detailsub: {
        fontFamily: FontFamilySwitch().regular,
        color: "#98A0AC",
        fontSize: "0.875rem",

    },
    build: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold
    },
    build1: {
        fontSize: "0.75rem",
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().regular
    },
    dot: {
        height: "6px",
        width: "6px",
        borderRadius: "50%",
        backgroundColor: "#CED3DD",
        margin: "6px",
    },
    availabe: {
        fontSize: "0.75rem",
        color: "#5AC782",
        fontFamily: FontFamilySwitch().bold,
        backgroundColor: "#EEF9EE",
        padding: "2px 8px",
        borderRadius: theme.palette.borderRadius,
        display: "inline-block",

    },
    unitTag: {
        fontSize: "0.75rem",
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().bold,
        backgroundColor: "#F5F7FA",
        padding: "2px 8px",
        borderRadius: theme.palette.borderRadius,
        display: "inline-block",
        marginTop: "4px",
        marginLeft: "8px"
    },
    border: {
        borderBottom: "1px solid #E4E8EE"
    },
    loc: {
        fontSize: "0.875rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().regular,
    },
    viewall: {
        fontSize: "0.875rem",
        cursor: "pointer",
        color: "#5078E1",
        fontFamily: FontFamilySwitch().bold,
    },
    unitSub: {
        fontSize: "0.875rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().regular,
        marginTop: "8px"
    },
    rental: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
    },
    rental1: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().semiBold,
        marginTop: "12px"
    },
    rental1bold: {
        fontSize: "0.875rem",
        color: "#091B29",
        fontFamily: FontFamilySwitch().bold,

    },
    viewdetail: {
        fontSize: "0.75rem",
        cursor: "pointer",
        color: "#5078E1",
        fontFamily: FontFamilySwitch().bold,
    },
    UnitCardroot: {
        padding: "12px",
        border: "1px solid #E4E8EE",
        borderRadius: "4px",
        backgroundColor: "white"
    },
    unitCardImg: {
        height: "120px",
        width: "100%",
        borderRadius: theme.palette.borderRadius,
        objectFit: "cover"

    },
    unitCardImgdiv: {
        position: "relative",
        borderRadius: theme.palette.borderRadius,
        overflow: "hidden"
    },
    unitName: {
        fontSize: "0.875rem",
        color: "#091B29",
        fontFamily: FontFamilySwitch().bold,
    },
    shortlistBTN: {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "white",
        padding: "8px",
    },
    shortlistBTNactive: {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "#5078E1",
        padding: "8px",
        color: "white",
        '&:hover':{
            backgroundColor:"white",
        }
    },
    dialog: {
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
        },
    },
    shortlistbtnlong: {
        padding: "6px 16px",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        marginTop: "12px",
        fontSize: "0.875rem"
    },
    cancelBtn: {
        backgroundColor: "#F1F7FF",
        boxShadow: 'none',
        fontSize: "0.75rem",
        color: "#4E5A6B",
        borderRadius: "6px",
        fontFamily: FontFamilySwitch().semiBold

    },
    addImg: {
        position: "relative",
        backgroundColor: "#504e4e3d",
        borderRadius: "10px",
        height: "80px",
        cursor: "pointer"
    },
    plus: {
        position: "absolute",
        textAlign: "center",
        left: "0px",
        right: "0px",
        top: "30%",
        color: "white",
        fontFamily: FontFamilySwitch().semiBold

    },
    list: {
        '&.MuiListItem-root': {
            width: '135px !important',
            padding: '0px!important',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            border: '1px solid #E4E8EE',
            cursor: 'pointer',
            marginTop: "-4px"
        }
    },
    tabname: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
        cursor: 'pointer'
    },
    imagebox1: {
        padding: '16px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 16px #00000014',
        borderRadius: '12px',
        height: "400px",
        overflow: "auto"
    },
    imagebox: {
        textAlign: 'center',
        padding: '23px 16px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 16px #00000014',
        borderRadius: '12px',
    },
    listText: {
        backgroundColor: '#5078E1',
        width: '120px !important',
        color: '#fff',
        borderRadius: '6px',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        marginTop: "-4px"
    },
    tabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().bold,
    },
    tabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: FontFamilySwitch().bold,
    },
    subtabtitle: {
        fontSize: "0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().regular,
    },
    accordion: {
        boxShadow: "none"
    },
    accordionDetails: {
        // "& .css-15v22id-MuiAccordionDetails-root": {
        //     padding: "8px 0px"
        // }
    },
    dialogclose: {
        borderRadius: theme.palette.borderRadius,
        border: "1px solid #E4E8EE",
        backgroundColor: "white",
        "&:hover": {
            borderRadius: theme.palette.borderRadius,
            border: "1px solid #E4E8EE",
            backgroundColor: "white",
        }

    },
    discountValue: {
        fontSize: "0.875rem",
        color: '#FF9340',
        fontFamily: FontFamilySwitch().bold,
    },
    discountAppliedRoot: {
        fontSize: "0.75rem",
        color: '#FF9340',
        fontFamily: FontFamilySwitch().bold,
        backgroundColor: "#FFF4EB",
        borderRadius: theme.palette.borderRadius,
        padding: "2px 8px",
        position: "absolute",
        bottom: "6px",
        right: "0px"
    },
    type: {
        position: "absolute",
        bottom: "14px",
        left: "0px",
        textAlign: "center",
        backgroundColor: "#071741",
        color: "white",
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        padding: "4px 8px",
        borderRadius: "0px 8px 8px 0px"
    },
    tax: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().semiBold,
        marginTop: "2px"
    },
}));